import { DateTime } from "luxon";
export const toLocalTimeFromIso = (time) => {
  const dateTimeUTC = DateTime.fromISO(time, { zone: "utc" });
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dateTime = dateTimeUTC.setZone(userTimeZone);
  const formattedDate = dateTime.toFormat("dd-MM-yyyy HH:mm");

  return formattedDate;
};
